import Vue from 'vue'
import * as jsonpatch from 'fast-json-patch/index.mjs'

const luNoteType = {
  state: {
    luNoteTypes: [],
    selectedLuNoteType: {},
    selectedLuNoteTypeOriginal: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    luNoteTypes(state) {
      return state.luNoteTypes
    },
    selectedLuNoteType(state) {
      return state.selectedLuNoteType
    },
    selectedLuNoteTypeOriginal(state) {
      return state.selectedLuNoteTypeOriginal
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    luNoteTypes(state, payload) {
      state.luNoteTypes = payload
    },
    selectedLuNoteType(state, payload) {
      state.selectedLuNoteType = JSON.parse(JSON.stringify(payload))
    },
    selectedLuNoteTypeOriginal(state, payload) {
      state.selectedLuNoteTypeOriginal = JSON.parse(JSON.stringify(payload))
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedLuNoteType(context, payload) {
      context.commit('selectedLuNoteType', payload)
    },
    async loadLuNoteTypes(context, payload) {
      const url = 'LuNoteType'
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('luNoteTypes', res.data)
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    refreshSelectedLuNoteType(context, payload) {
      if (context.state.selectedLuNoteType && context.state.selectedLuNoteType.Id > 0) {
        context.dispatch('loadSelectedLuNoteType', context.state.selectedLuNoteType.Id)

      }
    },
    async loadSelectedLuNoteType(context, payload) {
      if (context.state.selectedLuNoteType && context.state.selectedLuNoteType.Id != payload) {
        context.commit('selectedLuNoteType', {})
      }
      const url = 'LuNoteType/' + payload
      context.commit('increaseSearchCount')
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('selectedLuNoteType', res.data)
        context.commit('selectedLuNoteTypeOriginal', res.data)
        context.commit('decreaseSearchCount')
        return res
      } catch (err) {
        console.error(err)
        context.commit('decreaseSearchCount')
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    clearLookupCacheAndReloadLuNoteTypes(context, payload) {
      caches.delete('apilookup-cache').finally(() => {
          context.dispatch('loadLuNoteTypes')
      }, )
    },
    async createLuNoteType(context, payload){
      const url = `LuNoteType`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios.post(url, payload)
        context.dispatch('messages/toastMessage',
        {color: 'success', message: 'note type created',},{ root: true })
        //if you will always need to reload the list after an item is created
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadLuNoteTypes')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async patchLuNoteType(context, payload){
      var item = context.state.selectedLuNoteType
      if (payload.Id && 
      payload.Id == context.state.selectedLuNoteTypeOriginal.Id)  {
      item = payload
      }
      var patchPayload = {}
      if (!payload.patchDoc || !payload.Id) {
        let original = context.state.selectedLuNoteTypeOriginal
        let current = item
        patchPayload.Id = item.Id
        var diff = jsonpatch.compare(
              original,
              current
            )
        patchPayload.patchDoc = diff

      } else {
        patchPayload = payload
      }
      if (patchPayload.patchDoc.length > 0) {
        const url = `LuNoteType/${ patchPayload.Id }`
        context.commit('saving', true)
        try {
          let res = await Vue.prototype.$axios
          .patch(url, patchPayload.patchDoc)
          context.dispatch('messages/toastMessage',
          {color: 'success', message: 'note type updated',},{ root: true })
          //if you will always need to reload the list after an update
          //you can uncomment out the following dispatch line.
          //Alternatively you can reload whatever object you need
          //when the promise resolves in the component that called it.
          //context.dispatch('loadLuNoteTypes')
          context.commit('saving', false)
          return res
        } catch (err) {
          console.error(err)
          context.commit('saving', false)
          context.dispatch('errors/handleError', err, { root: true })
          throw err
        }
      } else {
        return 'no changes'
      }
    },
    async updateLuNoteType(context, payload){
      const url = `LuNoteType/${ payload.Id }`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios
          .put(url, payload)
        context.dispatch('messages/toastMessage',
        {color: 'success', message: 'note type updated',},{ root: true })
        //if you will always need to reload the list after an update
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadLuNoteTypes')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async saveLuNoteType(context, payload){
      if (payload.Id > 0) {
        return context.dispatch('updateLuNoteType', payload)
      } else {
        return context.dispatch('createLuNoteType', payload)
      }
    },
    async deleteLuNoteType(context, payload){
      const url = `LuNoteType/${ payload.Id }`
      try {
        let res = await Vue.prototype.$axios.delete(url)
        context.dispatch('messages/toastMessage',
        {color: 'success', message: 'note type deleted',},{ root: true })
        //if you will always need to reload the list after a delete
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadLuNoteTypes')
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
  },
}

export default luNoteType